import React from "react";
import QRCodeGenerator from "./QRCodeGenerator";
import CopyLink from "./CopyLink";
import AppButton from "components/ui/AppButton.jsx";
import { useTranslation } from "react-i18next";

function DineIn({
  settings,
  orderPageLink,
  stores,
  qrCodeSetting,
  handleDownload,
}) {
  const { t } = useTranslation();
  return (
    <div className="w-full lg:w-1/2">
      {stores?.map((store, index) => {
        return store?.isDineInEnabled ? (
          <div
            key={index}
            className="mb-5"
          >
            <h2 className="px-2 w-full lg:w-2/3 capitalize text-gray-900  text-17px font-semibold">
              {store?.label}
            </h2>
            <QRCodeGenerator
              type="dine-in"
              id={store?.value}
              orderPageLink={`${orderPageLink}/dine-in?store-id=${store?.value}&service-type=dine-in&table-number=0000`}
              {...{
                settings,
                qrCodeSetting,
              }}
              size={150}
            />
            <div className="flex flex-col md:flex-row gap-3- ml-2">
              <CopyLink orderPageLink={`${orderPageLink}/dine-in?store-id=${store?.value}&service-type=dine-in&table-number=0000`}/>
              <AppButton
                type="button"
                onClick={() => handleDownload(store?.value)}
                className="mt-3 md:mt-0"
              >
                {t("Download QR code")}
              </AppButton>
            </div>

          </div>
        ) : null;
      })}
    </div>
  );
}

export default DineIn;
